import axios from "axios";

const expertosNacionales = {
  state: () => ({
    expertosNacionales: [],
    expertoNacional: {}
  }),

  getters: {
    obtenerExpertosNacionales: (state) => {
      return state.expertosNacionales
    },
    
    obtenerExpertoNacional: (state) => {
      return state.expertoNacional
    },

    obtenerExpertoNacionalIdentificacion: (state) => (identificacion) => {
      return state.expertosNacionales.find(expertoNacional => expertoNacional.identificacion == identificacion)
    },
  },

  mutations: {
    enviarExpertosNacionales(state, expertosNacionales) {
      state.expertosNacionales = expertosNacionales
    },

    enviarExpertoNacional(state, expertoNacional) {
      state.expertoNacional = expertoNacional
    }
  },

  actions: {
    registrarExpertoNacional(context, experto) {
      return new Promise((resolve, reject) => {
        axios.post("api/worldskills/expertosNacionales", experto)
        .then((response) => resolve(response.data))
        .catch(() => reject())
      })
    },

    gestionarExpertosNacionales(context, competencia) {
      axios.get(`api/worldskills/competencias/${competencia}/expertosNacionales`)
      .then((response) => {
        const expertosNacionales = []
        response.data.results.forEach((response) => {
          expertosNacionales.push({
            id:                   response.id_lider,
            competencia_id:       response.competencia.id_competencia,
            competencia:          response.competencia.competencia,
            categoria_id:         response.categoria.id_categoria,
            categoria:            response.categoria.categoria,
            tipo_lider_id:        response.tipo_lider.id_tipo_lider,
            tipo_lider:           response.tipo_lider.tipo_lider,
            centro_formacion_id:  response.centro_formacion.id_centro_formacion,
            centro_formacion:     response.centro_formacion.centro_formacion,
            regional_id:          response.centro_formacion.regional.id_regional,
            regional:             response.centro_formacion.regional.regional,
            persona_id:           response.persona.id_persona,
            identificacion:       response.persona.identificacion,
            nombres:              response.persona.primer_nombre+ " " +response.persona.segundo_nombre,
            apellidos:            response.persona.primer_apellido+ " " +response.persona.segundo_apellido,
            telefono_movil:       response.persona.telefono_movil,
            correo:               response.persona.correo,
            fecha_nacimiento:     response.persona.fecha_nacimiento,
            genero:               response.persona.genero.genero,
            cargo:                response.cargo,
            talla_camiseta:       response.talla_camiseta
          })
        });

        context.commit("enviarExpertosNacionales", expertosNacionales)
      })
      .catch(() => { })
    },

    detallesExpertoNacional(context, id) {
      axios.get("api/worldskills/expertosNacionales/"+id)
      .then((response) => {
        const detalles = response.data.results

        const expertoNacional = {
          id:                     detalles.id_lider,
          competencia_id:         detalles.competencia.id_competencia,
          competencia:            detalles.competencia.competencia,
          categoria_id:           detalles.categoria.id_categoria,
          categoria:              detalles.categoria.categoria,
          tipo_lider_id:          detalles.tipo_lider.id_tipo_lider,
          tipo_lider:             detalles.tipo_lider.tipo_lider,
          centro_formacion_id:    detalles.centro_formacion.id_centro_formacion,
          centro_formacion:       detalles.centro_formacion.centro_formacion,
          regional_id:            detalles.centro_formacion.regional.id_regional,
          regional:               detalles.centro_formacion.regional.regional,
          persona_id:             detalles.persona.id_persona,
          tipo_identificacion_id: detalles.persona.tipo_identificacion_id,
          identificacion:         detalles.persona.identificacion,
          nombres:                detalles.persona.primer_nombre+" "+detalles.persona.segundo_nombre,
          apellidos:              detalles.persona.primer_apellido+" " +detalles.persona.segundo_apellido,
          correo:                 detalles.persona.correo,
          telefono_movil:         detalles.persona.telefono_movil,
          direccion:              detalles.persona.direccion,
          fecha_nacimiento:       detalles.persona.fecha_nacimiento,
          genero_id:              detalles.persona.genero_id,
          genero:                 detalles.persona.genero.genero,
          estado_civil_id:        detalles.persona.estado_civil_id,
          estrato:                detalles.persona.estrato,
          zona_id:                detalles.persona.zona_id,
          discapacidad_id:        detalles.persona.discapacidad_id,
          cargo:                  detalles.cargo,
          talla_camiseta:         detalles.talla_camiseta,
        };

        context.commit("enviarExpertoNacional", expertoNacional);
      })
      .catch(() => {});
    },

    actualizarExpertoNacional(context, experto) {
      return new Promise((resolve, reject) => {
        axios.put("api/worldskills/expertosNacionales/"+experto.id, experto)
        .then((response) => resolve(response.data))
        .catch(() => reject())
      })
    },

    eliminarExpertoNacional(context, experto) {
      return new Promise((resolve, reject) => {
        axios.delete("api/worldskills/expertosNacionales/"+experto)
        .then((response) => resolve(response.data))
        .catch(() => reject())
      })
    }
  }
}

export default expertosNacionales